// hooks/useNumberFormatter.js
import { useCallback } from "react";

const useNumberFormatter = () => {
  return useCallback((number) => {
    if (number !== undefined && number !== null) {
      return number.toLocaleString(); // Formats the number with commas
    }
    return "";
  }, []);
};

export default useNumberFormatter;
